module.exports = __webpack_public_path__ + "img/logocopy.edc7d222.png";